import { render, staticRenderFns } from "./AppTenant.vue?vue&type=template&id=2ef5e9d4&"
import script from "./AppTenant.vue?vue&type=script&lang=js&"
export * from "./AppTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports